import baseForOwn from './_baseForOwn.js';
import createBaseEach from './_createBaseEach.js';

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

export default baseEach;



//////////////////
// WEBPACK FOOTER
// ../~/lodash-es/_baseEach.js
// module id = 334
// module chunks = 0